import { schema } from 'normalizr';

const entities = (key, definition = {}, options = {}) => {
  const entity = new schema.Entity(key, definition, options);
  const idAttribute = options.idAttribute || 'id';
  entity.getIdAttribute = () => idAttribute;
  return [entity, [entity]];
};

const processStrategy = entity => {
  const { id, item, score, type } = entity;
  return item ? { ...item, id, score, type } : entity;
};

export const getID = (idAttribute, entity) =>
  typeof idAttribute === 'function' ? idAttribute(entity) : entity[idAttribute];

export const getIDFromSchema = (schema, entity) =>
  getID(schema.getIdAttribute(), entity);

export const mapEntitiesByID = (array, id = 'id') =>
  array.reduce((o, v) => ({ ...o, [getID(id, v)]: v }), {});

export const getEntityByID = (entityMap, schema, entity) =>
  entityMap[getIDFromSchema(schema, entity)];

export const [APP, APP_LIST] = entities('apps', {}, { idAttribute: 'appID' });

export const [AUTH_INFO] = entities('auth_info', {}, { idAttribute: 'method' });

export const [CONTACT, CONTACT_LIST] = entities('contacts');

export const [FIELD, FIELD_LIST] = entities(
  'fields',
  {},
  { idAttribute: 'path' }
);

export const [VISIBLE_FIELD, VISIBLE_FIELD_LIST] = entities(
  'visibleFields',
  {},
  { idAttribute: 'fieldID' }
);

export const [CREDENTIAL, CREDENTIAL_LIST] = entities(
  'credentials',
  {},
  {
    idAttribute: entity =>
      entity.item ? entity.item.credentialID : entity.credentialID
  }
);

export const [FILE, FILE_LIST] = entities(
  'files',
  {},
  { idAttribute: 'fileID' }
);

export const [GROUP, GROUP_LIST] = entities(
  'groups',
  {},
  { idAttribute: 'userID' }
);

export const [INTEGRATION, INTEGRATION_LIST] = entities(
  'integrations',
  {},
  { idAttribute: 'userID' }
);

export const [INVITE, INVITE_LIST] = entities(
  'invites',
  {},
  { idAttribute: 'inviteID' }
);

export const [MESSAGE, MESSAGE_LIST] = entities(
  'messages',
  {},
  { idAttribute: 'messageID' }
);

export const [NOTIFICATION, NOTIFICATION_LIST] = entities(
  'notifications',
  {},
  { idAttribute: 'notificationID' }
);

export const [STEP, STEP_LIST] = entities(
  'steps',
  {},
  { idAttribute: step => `${step.processID}:${step.stepName}` }
);

export const [PREDICTOR, PREDICTOR_LIST] = entities(
  'predictors',
  {},
  { idAttribute: 'predictorID' }
);

export const [PROCESS, PROCESS_LIST] = entities(
  'processes',
  { steps: STEP_LIST, fields: FIELD_LIST },
  {
    idAttribute: entity =>
      entity.item ? entity.item.processID : entity.processID,
    processStrategy
  }
);

export const [REMINDER, REMINDER_LIST] = entities(
  'reminders',
  {},
  { idAttribute: 'reminderID' }
);

export const [TABLE, TABLE_LIST] = entities(
  'tables',
  { columns: FIELD_LIST },
  {
    idAttribute: entity => (entity.item ? entity.item.tableID : entity.tableID),
    processStrategy
  }
);

export const [TABLE_ROW, TABLE_ROW_LIST] = entities(
  'tableRows',
  { fields: FIELD_LIST },
  { idAttribute: 'rowID' }
);

export const [TASK, TASK_LIST] = entities(
  'tasks',
  { fields: FIELD_LIST },
  {
    idAttribute: entity => (entity.item ? entity.item.taskID : entity.taskID),
    processStrategy
  }
);

export const [TEAM, TEAM_LIST] = entities(
  'teams',
  {},
  { idAttribute: 'teamName' }
);

export const [THREAD, THREAD_LIST] = entities(
  'threads',
  { messages: MESSAGE_LIST },
  {
    idAttribute: 'threadID'
  }
);

export const [RUN, RUN_LIST] = entities(
  'runs',
  { tasks: TASK_LIST, threadID: THREAD, fields: FIELD_LIST },
  {
    idAttribute: entity => (entity.item ? entity.item.runID : entity.runID),
    processStrategy
  }
);

export const [TRAINING, TRAINING_LIST] = entities(
  'trainings',
  {},
  { idAttribute: 'trainingID' }
);

export const [TRIGGER, TRIGGER_LIST] = entities(
  'triggers',
  {},
  { idAttribute: 'triggerID' }
);

export const [USER, USER_LIST] = entities(
  'users',
  {},
  { idAttribute: 'userID' }
);

export const [WEBHOOK, WEBHOOK_LIST] = entities(
  'webhooks',
  {},
  { idAttribute: 'webhookID' }
);

export const [FILTER, FILTER_LIST] = entities(
  'filters',
  {},
  { idAttribute: 'filterID' }
);

const RESULT_LIST = new schema.Array(
  {
    processes: PROCESS,
    runs: RUN,
    tables: TABLE,
    tasks: TASK
  },
  entity => entity.type
);

export const SEARCH = new schema.Entity(
  'searches',
  { results: RESULT_LIST },
  { idAttribute: 'searchID' }
);



// WEBPACK FOOTER //
// ./js/schemas.js